import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Fade } from '@mui/material';

import { GetNotifications } from "../../redux/notification/actions";

import CustomTableV2 from '../../common/CustomTableV2';
import "./style.css";
import moment from 'moment';

function Notification(props) {

    return (
        <>
            <Fade in>
                <div id="notification-panel" className="main-container">
                    <CustomTableV2
                        title="NOTIFICATIONS"
                        description="Overview of notifications sent to users."
                        store={props.Notification}
                        table={{
                            headers: [
                                { title: "#" },
                                { title: "Name", value: "name", },
                                { title: "Type", value: "notificationType", },
                                { title: "AI", value: "ai_log", },
                                { title: "Header", value: "metadata", },
                                { title: "Message", value: "message", },
                                { title: "Date Sent", value: "dateSent", },
                                // { title: "Sent To", value: "", },
                                { title: "Status", value: "", },
                                { title: "Date Clicked", value: "", },
                            ],
                            body: (notification, i) => {

                                const metadata = JSON.parse(notification?.metadata);
                                return (
                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                        <td><h5>{i}</h5></td>
                                        <td><h5>{(notification?.last_name + ", " + notification?.first_name)?.toUpperCase()}</h5></td>
                                        <td><h5>{notification?.notificationType?.toUpperCase()}</h5></td>
                                        <td><h5>{notification?.ai_log ? "1" : "0"}</h5></td>
                                        <td><h5>{metadata?.header?.toUpperCase()}</h5></td>
                                        <td><h5>{notification?.message}</h5></td>
                                        <td><h5>{moment(notification?.dateSent).format("MM/DD/YYYY-HH:mm:ss")}</h5></td>
                                        {/* <td><h5>{notification?.os}</h5></td> */}
                                        <td><h5>{notification?.status ? "1" : "0"}</h5></td>
                                        <td><h5>{notification?.clickedAt ? moment(notification?.dateSent).format("MM/DD/YYYY-HH:mm:ss") : ""}</h5></td>
                                    </tr>
                                )
                            }
                        }}
                        actions={{
                            get: (page, count, filter, sort) => {
                                props.GetNotifications(page, count, filter, sort);
                            }
                        }}
                    />

                </div>
            </Fade>
        </>
    );
}

const mapStateToProps = (state) => ({
    Notification: state.Notification
})

export default connect(mapStateToProps, {
    GetNotifications,
})(Notification);
